import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import { menuData } from "./MenuData"

const NavOptions = () => {
  return (
    <Container>
      {menuData.map((item, index) => (
        <NavLink key={index} to={item.path}>
          {item.title}
        </NavLink>
      ))}
    </Container>
  )
}

export default NavOptions

const Container = styled.div`
  margin-bottom: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (min-width: 768px) {
    flex-direction: initial;
    margin-bottom: initial;
  }
`

const NavLink = styled(Link)`
  color: #251a41;
  text-decoration: none;
  display: flex;
  justify-content: center;
  font-size: 1.4rem;

  :not(:last-child) {
    margin-bottom: 2vh;
  }

  :first-child {
    margin-top: 4vh;
  }

  @media screen and (min-width: 768px) {
    :not(:last-child) {
      margin-bottom: 0;
      margin-right: 5vw;
    }

    :first-child {
      margin-top: 0;
    }
  }
`
